import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../../components/ui/dialog";
import { api, errMsg, fmt } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import MapView from "../../map/MapView";
import { Field, btnGhost, btnPrimary, inputCls } from "../../components/ui";
import AdminDeliveries from "./AdminDeliveries";

const ACTIVE = ["assigned", "accepted", "picked_up", "in_transit"];

function LiveMap() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const load = () => api.get("/admin/deliveries").then(({ data }) => setItems((data.deliveries || []).filter((d) => ACTIVE.includes(d.status))));
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, []);
  const markers = items.flatMap((d) => [
    d.last_location && { key: `c-${d.id}`, pos: d.last_location, icon: "courier", label: `${d.courier_name} · ${d.order_number}` },
    d.destination && { key: `d-${d.id}`, pos: d.destination, icon: "dest", label: `Destino ${d.order_number}` },
  ].filter(Boolean));
  return (
    <section className="bo-card flex flex-col gap-2 p-4" data-testid="obogo-live-map">
      <h3 className="font-bold">Entregas ativas no mapa · {items.length}</h3>
      <p className="text-xs text-gray-500">Posição do estafeta só durante entregas ativas com partilha autorizada. Atualiza a cada 15 s.</p>
      <MapView height={300} markers={markers} testid="obogo-live-map-view" />
    </section>
  );
}

function PayDialog({ row, onClose, onDone }) {
  const [f, setF] = useState({ amount: "", reference: "", reason: "" });
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post(`/admin/couriers/${row.courier_id}/payouts`, { ...f, amount: Number(f.amount) }); toast.success("Pagamento ao estafeta registado"); onDone(); } catch (e2) { toast.error(errMsg(e2)); }
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}><DialogContent data-testid="courier-payout-dialog">
      <DialogHeader><DialogTitle>Pagar a {row.name} · pendente {fmt(row.pending_total)}</DialogTitle></DialogHeader>
      <form onSubmit={submit} className="flex flex-col gap-3">
        <Field label="Valor (STN)"><input required type="number" min="0.01" step="0.01" value={f.amount} onChange={set("amount")} className={inputCls} data-testid="courier-payout-amount" /></Field>
        <Field label="Referência"><input required minLength={3} value={f.reference} onChange={set("reference")} className={inputCls} data-testid="courier-payout-reference" /></Field>
        <Field label="Motivo / período"><input required minLength={3} value={f.reason} onChange={set("reason")} className={inputCls} data-testid="courier-payout-reason" /></Field>
        <button className={btnPrimary} data-testid="courier-payout-submit">Registar pagamento</button>
      </form>
    </DialogContent></Dialog>
  );
}

function Earnings() {
  const { user } = useAuth();
  const [days, setDays] = useState(30);
  const [d, setD] = useState(null);
  const [pay, setPay] = useState(null);
  const load = () => api.get("/admin/couriers/earnings", { params: { days } }).then(({ data }) => setD(data));
  useEffect(() => { load(); }, [days]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  return (
    <section className="bo-card flex flex-col gap-2 p-4 text-sm" data-testid="courier-earnings">
      <div className="flex items-center gap-2"><h3 className="flex-1 font-bold">Remuneração dos estafetas</h3>
        <select value={days} onChange={(e) => setDays(Number(e.target.value))} className={`${inputCls} w-auto`} data-testid="courier-earnings-days">{[7, 30, 90, 365].map((x) => <option key={x} value={x}>{x} dias</option>)}</select></div>
      <p className="text-xs text-gray-500">Regra atual: {fmt(d.rates.per_delivery)} por entrega + {d.rates.percent_of_fee}% da taxa (alterar em Configurações).</p>
      {d.couriers.map((c) => <div key={c.courier_id} className="flex flex-wrap items-center gap-3 border-t border-gray-50 py-2" data-testid={`courier-earning-${c.courier_id}`}>
        <span className="flex-1 font-medium">{c.name}</span><span>{c.deliveries} entregas</span><span>ganho {fmt(c.earned)}{c.unrated > 0 && ` (${c.unrated} sem tarifa)`}</span><strong>pendente {fmt(c.pending_total)}</strong>
        {user.permissions?.includes("finance.manage") && c.pending_total > 0 && <button onClick={() => setPay(c)} className={`${btnGhost} px-3 py-1`} data-testid={`courier-pay-btn-${c.courier_id}`}>Pagar</button>}</div>)}
      {!d.couriers.length && <p className="text-gray-500">Sem entregas concluídas no período.</p>}
      {pay && <PayDialog row={pay} onClose={() => setPay(null)} onDone={() => { setPay(null); load(); }} />}
    </section>
  );
}

export default function AdminObogo() {
  return <div className="flex flex-col gap-4"><LiveMap /><AdminDeliveries /><Earnings /></div>;
}
